import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Search page.
 */
export function SearchPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton showDescription={true} />}>
      <div className="space-y-6 py-8">
        {/* Search Input */}
        <div className="flex gap-2">
          <Skeleton className="h-12 flex-1" />
          <Skeleton className="h-12 w-24" />
        </div>

        {/* Category Tabs */}
        <div className="flex gap-2 border-b border-border pb-2">
          {['All', 'Bills', 'Legislators', 'Committees'].map((cat) => (
            <Skeleton key={cat} className="h-9 w-24" />
          ))}
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-24" />
        </div>

        {/* Results */}
        <div className="space-y-4">
          <Skeleton className="h-4 w-32" />
          <CardGridSkeleton count={6} />
        </div>
      </div>
    </PageWrapper>
  );
}
